<template>
  <div class="mds-page">
    <h2 class="mds-title">Maps <FiFavStar /></h2>
    <p class="mds-section-sub">Live and historical map views for your fleet.</p>

    <div class="mds-card-grid">
      <router-link
        v-for="card in mapItems"
        :key="card.route || card.path"
        :to="card.path ? { path: card.path } : { name: card.route }"
        :target="card.external ? '_blank' : null"
        :rel="card.external ? 'noopener' : null"
        class="mds-card"
      >
        <div class="mds-card-icon">
          <i :class="'fa ' + card.icon" aria-hidden="true"></i>
          <i v-if="card.external" class="fa fa-external-link mds-card-ext-icon" aria-hidden="true"></i>
        </div>
        <div class="mds-card-title">{{ card.name }}</div>
        <div class="mds-card-desc">{{ card.description }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { buildMapItems } from '@/utils/map_pages'

export default {
  name: 'map_dashboard_shell',
  computed: {
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    mapItems() { return buildMapItems(this.user, this.viewAs) },
  },
}
</script>

<style scoped>
.mds-page {
  padding-bottom: 40px;
}

.mds-title {
  font-size: 26px;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
}

.mds-section-sub {
  color: #555;
  font-size: 14px;
  margin-bottom: 24px;
}

.mds-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  padding-right: 16px;
}

.mds-card {
  border: 1px solid #d0d8e4;
  border-radius: 6px;
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(70, 130, 180, 0.08);
  transition: box-shadow 0.15s, border-color 0.15s;
  cursor: pointer;
  text-decoration: none !important;
}

.mds-card:hover {
  border-color: steelblue;
  box-shadow: 0 2px 8px rgba(70, 130, 180, 0.18);
  text-decoration: none !important;
}

.mds-card-icon {
  color: steelblue;
  font-size: 20px;
  margin-bottom: 8px;
}

.mds-card-ext-icon {
  margin-left: 6px;
  color: #9aa7b4;
  font-size: 12px;
}

.mds-card-title {
  font-size: 15px;
  font-weight: bold;
  color: #222;
  margin-bottom: 6px;
}

.mds-card-desc {
  font-size: 13px;
  color: #666;
  flex: 1;
  line-height: 1.4;
}
</style>
